<template>
  <section class="xs-channel-workspace">
    <table-toolbar
      :search.sync="search"
      :show-search="true"
      :show-refresh="true"
      :show-export="true"
      :export-loading="exportLoading"
      :show-column-settings="true"
      :columns="columnOptions"
      :visible-columns.sync="visibleColumns"
      :default-columns="defaultVisibleColumns"
      :fixed-columns="['# ID', '渠道名称', '操作']"
      :min-selected="4"
      search-placeholder="输入渠道 ID、名称或参数关键字..."
      export-confirm-title="确定导出当前筛选后的 XS 渠道数据吗？"
      @refresh="handleRefresh"
      @export="handleExport"
    >
      <template slot="left">
        <span class="reload-wrapper">
          <cache-reload reload-type="xsArgsLogin" btn-label="重载NACOS-登录参数" btn-icon="el-icon-user"/>
        </span>
        <span class="reload-wrapper">
          <cache-reload reload-type="channel" btn-label="重载NACOS-渠道"/>
        </span>
        <span class="reload-wrapper">
          <cache-reload reload-type="xsArgsPay" btn-label="重载NACOS-支付参数" btn-icon="el-icon-shopping-bag-2"/>
        </span>
      </template>
    </table-toolbar>

    <table-page
      :loading="loading"
      :empty="filteredChannels.length === 0"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :total="filteredChannels.length"
      :page-sizes="[10, 20, 50, 100, 200]"
      :show-top-pagination="filteredChannels.length > pageSize"
      :show-bottom-pagination="filteredChannels.length > pageSize"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      @retry="handleRefresh"
    >
      <el-table :data="pagedChannels" stripe style="width: 100%" class="premium-table">
        <el-table-column key="col-id" prop="id" width="100">
          <template slot="header"><span class="premium-header-title"># ID</span></template>
          <template slot-scope="scope"><span class="cell-id">{{ scope.row.id }}</span></template>
        </el-table-column>
        <el-table-column key="col-name" prop="name" min-width="160">
          <template slot="header"><span class="premium-header-title">渠道名称</span></template>
          <template slot-scope="scope">
            <el-link type="primary" class="cell-name-link" @click="handleEditXsArgsId(scope.$index, scope.row)">{{ scope.row.name }}</el-link>
          </template>
        </el-table-column>
        <el-table-column v-if="visibleColumns.includes('accountChannelId')" key="col-accountChannelId" prop="accountChannelId" label="账号渠道ID" width="125">
          <template slot-scope="scope"><span class="cell-text-gray">{{ scope.row.accountChannelId }}</span></template>
        </el-table-column>
        <el-table-column v-if="visibleColumns.includes('xsType')" key="col-xsType" prop="xsType" label="XsType" width="100" align="center">
          <template slot-scope="scope">
            <span :class="['xs-type-badge', scope.row.xsType === 1 ? 'official' : 'union']">{{ scope.row.xsType === 1 ? '官方' : '联运' }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="visibleColumns.includes('xsLoginArgsId')" key="col-xsLoginArgsId" prop="xsLoginArgsId" label="登录参数" min-width="130">
          <template slot-scope="scope">
            <logic-args-dialog :owner-type="0" :args-id="scope.row.xsLoginArgsId" :logic-type="1" :channel-id="scope.row.id"></logic-args-dialog>
          </template>
        </el-table-column>
        <el-table-column v-if="visibleColumns.includes('xsPayArgsId')" key="col-xsPayArgsId" prop="xsPayArgsId" label="支付参数" min-width="130">
          <template slot-scope="scope">
            <logic-args-dialog :owner-type="0" :args-id="scope.row.xsPayArgsId" :logic-type="2" :channel-id="scope.row.id"></logic-args-dialog>
          </template>
        </el-table-column>
        <el-table-column key="col-actions" align="center" width="80">
          <template slot="header"><span class="premium-header-title">操作</span></template>
          <template slot-scope="scope">
            <el-dropdown @command="handleActionCommand($event, scope.$index, scope.row)" trigger="hover">
              <el-button size="mini" class="action-btn" circle icon="el-icon-more-outline"></el-button>
              <el-dropdown-menu slot="dropdown" class="premium-dropdown-menu">
                <el-dropdown-item command="edit"><i class="el-icon-edit"></i> 编辑参数</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </table-page>

    <el-drawer
      :visible.sync="drawerVisible"
      direction="rtl"
      :size="drawerSize"
      append-to-body
      destroy-on-close
      custom-class="xs-channel-drawer"
      :with-header="false"
      @closed="resetDrawer"
    >
      <div class="drawer-header">
        <div class="drawer-title-wrap">
          <span class="drawer-title-icon"><i class="el-icon-edit-outline"></i></span>
          <span class="drawer-title">编辑 XS 参数绑定</span>
          <div class="drawer-header-actions">
            <el-button size="small" icon="el-icon-back" :disabled="saveLoading" @click="drawerVisible = false">返回列表</el-button>
            <el-button size="small" type="success" :loading="saveLoading" :disabled="saveLoading" @click="handleSubmitXsArgsId">保存</el-button>
          </div>
        </div>
        <el-button size="small" icon="el-icon-close" class="drawer-close-btn" aria-label="关闭" @click="drawerVisible = false"></el-button>
      </div>

      <div class="drawer-content">
        <el-form ref="form" :model="form" :rules="rules" label-position="right" label-width="150px" size="small" class="drawer-horizontal-form">
          <el-form-item prop="channelId" label="渠道号">
            <el-input v-model.number="form.channelId" placeholder="channelId" disabled></el-input>
          </el-form-item>
          <el-form-item prop="xsLoginArgsId" label="登录参数">
            <el-input v-model.number="form.xsLoginArgsId" placeholder="请填写 XsArgs 渠道号" clearable></el-input>
          </el-form-item>
          <el-form-item prop="xsPayArgsId" label="支付参数">
            <el-input v-model.number="form.xsPayArgsId" placeholder="请填写 XsArgs 渠道号" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="drawer-footer">
        <el-button size="small" @click="drawerVisible = false">取 消</el-button>
        <el-button size="small" type="primary" :loading="saveLoading" :disabled="saveLoading" class="btn-save" @click="handleSubmitXsArgsId">保 存</el-button>
      </div>
    </el-drawer>
  </section>
</template>

<script>
import LogicArgsDialog from '@/views/Xs/Args/LogicArgsDialog.vue'
import CacheReload from '@/components/CacheReload/index.vue'
import TablePage from '@/components/TablePage/index.vue'
import TableToolbar from '@/components/TableToolbar/index.vue'
import api from '@/api/channel'
import * as XLSX from 'xlsx'

export default {
  name: 'XsArgsChannel',
  components: { LogicArgsDialog, CacheReload, TablePage, TableToolbar },
  data () {
    const xsArgsIdRules = (rule, value, callback) => {
      if (!value) {
        callback()
        return
      }
      const min = this.appId * 1000
      const max = (this.appId + 1) * 1000
      if (typeof value !== 'number') {
        callback(new Error('请输入数字'))
      } else if (value < min) {
        callback(new Error('应大于等于' + min))
      } else if (value >= max) {
        callback(new Error('应小于' + max))
      } else {
        callback()
      }
    }
    return {
      xsType: 1,
      channelList: [],
      loading: false,
      exportLoading: false,
      saveLoading: false,
      drawerVisible: false,
      tableDataIndex: -1,
      search: '',
      currentPage: 1,
      pageSize: 20,
      form: {},
      defaultVisibleColumns: ['accountChannelId', 'xsType', 'xsLoginArgsId', 'xsPayArgsId'],
      visibleColumns: ['accountChannelId', 'xsType', 'xsLoginArgsId', 'xsPayArgsId'],
      columnOptions: [
        { prop: 'accountChannelId', label: '账号渠道ID' },
        { prop: 'xsType', label: 'XsType' },
        { prop: 'xsLoginArgsId', label: '登录参数' },
        { prop: 'xsPayArgsId', label: '支付参数' }
      ],
      rules: {
        xsLoginArgsId: [{ required: false, validator: xsArgsIdRules, trigger: 'blur' }],
        xsPayArgsId: [{ required: false, validator: xsArgsIdRules, trigger: 'blur' }]
      }
    }
  },
  computed: {
    appId () {
      return this.$store.getters.appId
    },
    drawerSize () {
      return this.$store.getters.isMobile ? '100%' : '50%'
    },
    filteredChannels () {
      const keyword = String(this.search || '').trim().toLowerCase()
      if (!keyword) return this.channelList
      return this.channelList.filter(row => Object.keys(row).some(key => String(row[key] ?? '').toLowerCase().includes(keyword)))
    },
    pagedChannels () {
      const start = (this.currentPage - 1) * this.pageSize
      return this.filteredChannels.slice(start, start + this.pageSize)
    }
  },
  watch: {
    appId (value, oldValue) {
      if (value !== oldValue) this.handleRefresh()
    },
    search () {
      this.currentPage = 1
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.loading = true
      return api.getXsTypeChannels(this.appId, this.xsType).then(res => {
        this.channelList = res || []
      }).finally(() => {
        this.loading = false
      })
    },
    handleRefresh () {
      this.currentPage = 1
      this.fetchData()
    },
    handleSizeChange () {
      this.currentPage = 1
    },
    handleCurrentChange (page) {
      this.currentPage = page
    },
    handleExport () {
      this.exportLoading = true
      try {
        const data = this.filteredChannels.map(row => ({
          渠道ID: row.id,
          渠道名称: row.name,
          账号渠道ID: row.accountChannelId,
          XsType: row.xsType,
          登录参数: row.xsLoginArgsId,
          支付参数: row.xsPayArgsId
        }))
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(data), 'XS渠道')
        XLSX.writeFile(workbook, `XS渠道-${new Date().getTime()}.xlsx`)
        this.$message.success('数据导出成功')
      } finally {
        this.exportLoading = false
      }
    },
    handleEditXsArgsId (index, row) {
      this.tableDataIndex = this.channelList.findIndex(item => item.id === row.id)
      this.form = {
        channelId: row.id,
        xsLoginArgsId: row.xsLoginArgsId,
        xsPayArgsId: row.xsPayArgsId
      }
      this.drawerVisible = true
    },
    resetDrawer () {
      this.tableDataIndex = -1
      this.form = {}
    },
    handleSubmitXsArgsId () {
      if (this.saveLoading) return
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saveLoading = true
        api.updateChannelXsArgsId(this.form).then(res => {
          const { code, msg, data } = res
          if (code === 200 && data) {
            this.channelList.splice(this.tableDataIndex, 1, data)
            this.$message.success('修改成功')
            this.drawerVisible = false
          } else {
            this.$message.error(`修改失败: ${msg}`)
          }
        }).finally(() => {
          this.saveLoading = false
        })
      })
    },
    handleActionCommand (command, index, row) {
      if (command === 'edit') this.handleEditXsArgsId(index, row)
    }
  }
}
</script>

<style scoped>
.xs-channel-workspace {
  padding: 16px 24px;
}

.reload-wrapper {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.reload-wrapper :deep(.el-button) {
  height: 32px;
  padding: 0 16px;
  border-color: #fed7aa !important;
  border-radius: 8px !important;
  background-color: #fff7ed !important;
  color: #c2410c !important;
  font-weight: 600 !important;
}

.reload-wrapper :deep(.el-button:hover) {
  border-color: #fdba74 !important;
  background-color: #ffedd5 !important;
  color: #9a3412 !important;
}

.premium-table {
  border-radius: 8px;
  overflow: hidden;
  border: none !important;
  font-size: 13px !important;
  color: var(--text-main) !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif !important;
}

.premium-table::before {
  display: none !important;
}

.premium-table :deep(.el-table__header-wrapper) th,
.premium-table :deep(.el-table__fixed-header-wrapper) th,
.premium-table :deep(.el-table__fixed-right-header-wrapper) th,
.premium-table :deep(th.el-table__fixed-column) {
  background-color: var(--bg-page) !important;
  color: var(--text-muted) !important;
  font-weight: 700 !important;
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-color) !important;
}

.premium-table :deep(.el-table__row) td {
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-light) !important;
}

.premium-table :deep(.el-table__row) {
  transition: background-color 0.2s ease;
}

.premium-table :deep(.el-table__row:hover) td {
  background-color: var(--bg-hover) !important;
}

.premium-table :deep(.el-table__body tr.hover-row > td),
.premium-table :deep(.el-table__body tr.hover-row.current-row > td),
.premium-table :deep(.el-table__body tr.hover-row.el-table__row--striped > td) {
  background-color: var(--bg-hover) !important;
}

.premium-header-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  color: inherit;
}

.header-icon-hash {
  font-family: Menlo, Monaco, Consolas, monospace;
  font-size: 13.5px;
  font-weight: 900;
  color: inherit;
}

.cell-id,
.cell-text-gray {
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace !important;
  font-size: 12.5px !important;
}

.cell-id {
  font-weight: 600;
  color: var(--text-muted);
}

.cell-text-gray {
  color: var(--text-muted);
}

.cell-name-link {
  font-size: 13.5px !important;
  font-weight: 700 !important;
  text-decoration: none !important;
}

.xs-type-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.xs-type-badge.official {
  background: rgba(37, 99, 235, 0.08);
  color: var(--primary-color);
}

.xs-type-badge.union {
  background: rgba(124, 58, 237, 0.08);
  color: #7c3aed;
}

.action-btn {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-color);
  color: var(--text-muted);
  background: var(--bg-card);
  transition: all 0.2s ease;
}

.action-btn:hover {
  background: var(--bg-hover);
  color: var(--text-main);
  border-color: var(--border-hover);
}

:deep(.xs-channel-drawer) {
  background: #f8fafc;
}

:deep(.xs-channel-drawer .el-drawer__body) {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 14px 20px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
}

.drawer-title-wrap {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
}

.drawer-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.drawer-header-actions .el-button + .el-button {
  margin-left: 0;
}

.drawer-title-icon {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(37, 99, 235, 0.08);
  color: var(--primary-color);
}

.drawer-title {
  color: #1e293b;
  font-size: 15px;
  font-weight: 700;
}

.drawer-close-btn {
  display: none !important;
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  border-color: #e2e8f0 !important;
  border-radius: 8px !important;
  color: #64748b !important;
}

.drawer-content {
  flex: 1;
  overflow-y: auto;
  margin: 12px;
  padding: 20px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
}

.drawer-horizontal-form :deep(.el-form-item) {
  display: flex;
  align-items: flex-start;
  margin-bottom: 18px;
}

.drawer-horizontal-form :deep(.el-form-item__label) {
  width: 150px !important;
  flex: 0 0 150px;
  padding-right: 16px;
  color: #475569;
  font-weight: 600;
  text-align: left;
}

.drawer-horizontal-form :deep(.el-form-item__content) {
  min-width: 0;
  flex: 1;
  margin-left: 0 !important;
}

.drawer-horizontal-form :deep(.el-input__inner) {
  border-color: #e2e8f0;
  border-radius: 8px;
}

.drawer-footer {
  display: none;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-shrink: 0;
  padding: 14px 20px;
  border-top: 1px solid #e2e8f0;
  background: #ffffff;
}

.drawer-footer .el-button + .el-button {
  margin-left: 0;
}

.btn-save {
  min-width: 72px;
  border-radius: 8px !important;
  font-weight: 600 !important;
}

@media (max-width: 768px) {
  .xs-channel-workspace {
    padding: 12px;
  }

  .drawer-content {
    margin: 8px;
    padding: 16px;
  }

  .drawer-horizontal-form :deep(.el-form-item) {
    display: block;
  }

  .drawer-horizontal-form :deep(.el-form-item__label) {
    width: 100% !important;
    padding-right: 0;
  }
}
</style>
